const previews = new Map<string, string>();

export function addPendingImagePreview(key: string, url: string): void {
  previews.set(key, url);
}

export function getPendingImagePreview(key: string): string | undefined {
  return previews.get(key);
}

export function releasePendingImagePreview(key: string): void {
  const url = previews.get(key);
  if (url) {
    URL.revokeObjectURL(url);
    previews.delete(key);
  }
}
